import type { IdealLineReference } from '@kangaroo/shared';

import { api } from '../../lib/api';
export {
  buildIdealLineMapPoints,
  idealLineReferenceStatusText,
} from '../../lib/idealLineReferenceModel';

export function idealLineReferenceKey(
  sessionKey: string | null | undefined,
  invalidationKey: string | number | null | undefined = null,
) {
  return sessionKey
    ? (['sessions', sessionKey, 'ideal-line', invalidationKey ?? 'current'] as const)
    : null;
}

export async function fetchIdealLineReference(sessionKey: string) {
  const response = await api.get<{ data: IdealLineReference }>(
    `/sessions/${encodeURIComponent(sessionKey)}/ideal-line`,
  );
  return response.data.data;
}
